export default __webpack_public_path__ + "media/images/icons/icon-social-inst-ac07ddf9b04b644fac3ab7625886d111.svg";